import React, { useRef, useEffect, useContext } from 'react'
import { ESW_CLASSNAMES } from '../../constants'
import AppContext from '../context/app'
import useGetPrice from '../hooks/useGetPrice'
import classNames from 'classnames'

export default function Price(props) {
    const {
        item,
        product,
        quantity = 1,
        style = {},
        className = '',
        eswPriceClassName = '',
    } = props
    
    const { country } = useContext(AppContext)
    const { price, baseprice } = useGetPrice(product)
    const discount = item?.discount_applied ? parseFloat(item?.discount_applied) : 0
    
    let value = (price?.promotion_price || price?.price) * quantity
    if (value && discount) value -= discount
    
    let basevalue = (baseprice?.promotion_price || baseprice?.price) * quantity
    if (basevalue && discount) basevalue -= discount
    
    const price_display = price ? `${price.currency_symbol}${value.toString().includes('.') ? value.toFixed(2) : value}` : ''
    const baseprice_display = baseprice ? `${baseprice.currency_symbol}${basevalue.toFixed(2)}` : ''
    
    const elRef = useRef(null)
    useEffect(() => {
        if(!elRef?.current) return
        elRef.current.innerText = price_display || baseprice_display
    }, [elRef, price, item])

    return (
        <>
            <span
                ref={elRef}
                style={style}
                data-bp-lti={baseprice_display}
                className={classNames(
                    className,
                    eswPriceClassName,
                )}
            >
            </span>

            {item && (
                <span
                    data-bp-lti={`${baseprice?.currency_symbol}${basevalue * quantity}`}
                    className={classNames(
                        ESW_CLASSNAMES.CARTITEM_SUBTOTAL,
                        'visually-hidden',
                    )}
                >
                    {(price && (country?.currencyIso === price?.currency)) && `${price?.currency_symbol}${value * quantity}`}
                </span>
            )}
        </>
    )
}
